import b from "./highrise961.mjs";
import { createTheme as v } from "./highrise678.mjs";
import I from "./highrise706.mjs";
import H from "./highrise949.mjs";
function S(r) {
  const {
    textColor1: e,
    textColor2: l,
    modalColor: t,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: s,
    closeColorHover: c,
    closeColorPressed: C,
    infoColor: m,
    successColor: a,
    warningColor: d,
    errorColor: g,
    primaryColor: f,
    dividerColor: u,
    borderRadius: o,
    fontWeightStrong: p,
    lineHeight: h,
    fontSize: x
  } = r;
  return Object.assign(Object.assign({}, b), {
    fontSize: x,
    lineHeight: h,
    border: `1px solid ${u}`,
    titleTextColor: e,
    textColor: l,
    color: t,
    closeColorHover: c,
    closeColorPressed: C,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: s,
    closeBorderRadius: o,
    iconColor: f,
    iconColorInfo: m,
    iconColorSuccess: a,
    iconColorWarning: d,
    iconColorError: g,
    borderRadius: o,
    titleFontWeight: p
  });
}
const O = v({
  name: "Dialog",
  common: H,
  peers: {
    Button: I
  },
  self: S
});
export {
  O as default,
  S as self
};
